module.exports = __webpack_public_path__ + "static/media/plus-symbol.8e43b2a4.svg";